export default __webpack_public_path__ + "static/media/lp-2-rMIN.d189630c.avif";